import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_plus",
  "use": "icon_plus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_plus\"><path fill=\"currentColor\" d=\"M5 11.5h-.5v1H5v-1Zm0 1h14v-1H5v1Z\" /><path fill=\"currentColor\" d=\"M12.5 5v-.5h-1V5h1Zm-1 0v14h1V5h-1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol